








































































































































































































import Vue from "vue";
import userManager from "@/services/userManager";
import appService from "@/services/appService";
import configProvider from "@common/services/configProvider";
import stateManager from "@common/services/stateManager";
import GlobalErrorSnackBar from "@/components/GlobalErrorSnackBar.vue";
import coreApiClient from "@/services/apis/coreApiClient";
import { Html5Qrcode } from "html5-qrcode";
import { encode } from "@common/util/base64Util";

export default Vue.extend({
  components: { GlobalErrorSnackBar },
  data() {
    return {
      self: this,
      mini: true,
      expandedItems: {},
      userManager,
      logoUrl: configProvider.get("LOGO_URL"),
      items: [
        {
          title: "Organizations",
          icon: "mdi-family-tree",
          to: "/app/tenants",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin", "cpoGroup"]);
          },
        },
        {
          title: "Partners",
          icon: "mdi-group",
          to: "/app/partners",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin"]);
          },
        },
        {
          title: "API Credentials",
          icon: "mdi-key-variant",
          to: "/app/api_credentials",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin"]);
          },
        },
        {
          title: "Map",
          icon: "mdi-map",
          to: "/app/maps",
          condition() {
            return !userManager.isUserMobile() && !userManager.checkRole(["cpoGroup"]);
          },
        },
        {
          title: "Site Area",
          icon: "mdi-map-marker-circle",
          to: "/app/site_area",
          condition() {
            return !userManager.isUserMobile() && userManager.checkRole(["cpoAdmin", "cpoMonitor"], false, true);
          },
        },
        {
          title: "Sites",
          icon: "mdi-map-marker",
          to: "/app/charging_locations",
          condition() {
            return !userManager.isUserMobile() && !userManager.checkRole(["cpoGroup"]);
          },
        },
        {
          title: "Sites",
          icon: "mdi-map-marker",
          to: "/app/charging_locations_m",
          condition() {
            return userManager.isUserMobile() && !userManager.checkRole(["cpoGroup"]);
          },
        },
        {
          title: "Retailers",
          icon: "mdi-select-group",
          to: "/app/retailers",
          condition() {
            return userManager.checkRole(["cpoAdmin", "cpoMonitor"], false, true);
          },
        },
        {
          title: "Charging Membership",
          icon: "mdi-account-star",
          to: "/app/charging_memberships",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]);
          },
        },
        {
          title: "Vouchers",
          icon: "mdi-ticket-percent-outline",
          to: "/app/vouchers",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin"]);
          },
        },
        // {
        //   title: "Membership History",
        //   icon: "mdi-account-star",
        //   to: "/app/charging_memberships_history",
        //   condition() {
        //     return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]);
        //   },
        // },
        // {
        //   title: "Promotion Moneys",
        //   icon: "mdi-cash-multiple ",
        //   to: "/app/promotion_moneys",
        //   condition() {
        //     return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]);
        //   },
        // },
        {
          title: "Promotional News",
          icon: " mdi-newspaper",
          to: "/app/promotional_news",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin"]);
          },
        },
        {
          title: "Licenses",
          icon: " mdi-key",
          to: "/app/licenses",
          condition() {
            return userManager.checkRole(["systemAdmin"]);
          },
        },
        {
          title: "Companion",
          icon: "mdi-account-network",
          to: "/app/companion",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin"]);
          },
        },
        {
          title: "Promotions",
          icon: "mdi-tag",
          to: "/app/promotions",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin"]);
          },
        },
        {
          title: "Cashback",
          icon: "mdi-cash-refund",
          key: "cashback",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin"], false, true);
          },
          items: [
            {
              title: "Local",
              to: "/app/cashback",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin"], false, true);
              },
            },
            {
              title: "Local Partner",
              to: "/app/cashback_partner",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin"], true);
              },
            },
            {
              title: "Roaming In",
              to: "/app/cashback_roaming_in",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin"], false, true);
              },
            },
            {
              title: "Roaming In Partner",
              to: "/app/cashback_roaming_in_partner",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin"], true);
              },
            },
            {
              title: "Roaming Out",
              to: "/app/cashback_roaming_out",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin"], false, true);
              },
            },
            {
              title: "Roaming Out Partner",
              to: "/app/cashback_roaming_out_partner",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin"], true);
              },
            },
          ],
        },
        {
          title: "Cashback",
          icon: "mdi-format-list-bulleted",
          key: "cashback_detail",
          condition() {
            return userManager.checkRole(["cpoGroup"], true);
          },
          items: [
            {
              title: "Local",
              to: "/app/cashback_partner_detail",
              condition() {
                return userManager.checkRole(["cpoGroup"], true);
              },
            },
            {
              title: "Roaming In",
              to: "/app/cashback_roaming_in_partner_detail",
              condition() {
                return userManager.checkRole(["cpoGroup"], true);
              },
            },
            {
              title: "Roaming Out",
              to: "/app/cashback_roaming_out_partner_detail",
              condition() {
                return userManager.checkRole(["cpoGroup"], true);
              },
            },
          ],
        },
        {
          title: "Revenue",
          icon: "mdi-cash-refund",
          to: "/app/cashback/" + userManager.getTenantId() + '?table_options=' + encode(JSON.stringify({
            "customPerPage": 0,
            "dataOptions": {
              "groupBy": [],
              "groupDesc": [],
              "itemsPerPage": 50,
              "multiSort": false,
              "mustSort": false,
              "page": 1,
              "sortBy": [
                "date"
              ],
              "sortDesc": [
                true
              ]
            },
            "filters": [
              {
                "key": "point",
                "operator": "greater_than",
                "value": 0
              }
            ]
          })),
          condition() {
            return userManager.checkRole(["cpoAdmin", "cpoMonitor", "retailer"], false, true);
          },
        },
        {
          title: "My Charger",
          icon: "mdi-battery-charging-high",
          to: "/app/my_charger/home_m",
          condition() {
            return userManager.isUserMobile();
          }
        },
        {
          title: "Charging Stations",
          icon: "mdi-ev-station",
          to: "/app/charging_stations",
          condition() {
            return !userManager.isGuest() && !userManager.isUserMobile();
          },
        },
        {
          title: "Charging Stations",
          icon: "mdi-ev-station",
          to: "/app/charging_stations_m",
          condition() {
            return !userManager.isGuest() && userManager.isUserMobile();
          },
        },
        {
          title: "Charging Sessions",
          icon: "mdi-clipboard-text-clock-outline",
          to: "/app/charging_sessions",
          condition() {
            return !userManager.isGuest() && !userManager.isUserMobile();
          },
        },
        {
          title: "Smart Socket",
          icon: "mdi-power-socket-au",
          to: "/app/smart_sockets",
          condition() {
            return configProvider.get("SMARTSOCKET_ENABLED")
              && !userManager.isGuest() && !userManager.isUserMobile()
              && userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "socketMonitor", "cpoGroup"]);
          },
        },
        {
          title: "Smart Socket Sessions",
          icon: "mdi-clipboard-text-clock-outline",
          to: "/app/smart_socket_sessions",
          condition() {
            return configProvider.get("SMARTSOCKET_ENABLED")
              && !userManager.isGuest() && !userManager.isUserMobile()
              && userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "socketMonitor", "cpoGroup"]);
          },
        },
        {
          title: "Plugged Sessions",
          icon: "mdi-clipboard-text-clock-outline",
          to: "/app/plugged_charging_sessions",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]);
          },
        },
        {
          title: "Retroactive Charges",
          icon: "mdi-currency-usd-off",
          to: "/app/retroactive_charges",
          condition(self) {
            return (
              userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) &&
              !!self.featureConfig?.retroactiveCharge?.enabled
            );
          },
        },
        {
          title: "Tariffs",
          icon: "mdi-cash-clock",
          to: "/app/tariffs",
          condition(self) {
            return (
              userManager.checkRole(["systemAdmin"]) &&
              !!self.featureConfig?.multiTierPricing?.enabled
            );
          },
        },
        {
          title: "Charger Vendors",
          icon: "mdi-hexagon-slice-4",
          to: "/app/charger_vendors",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]);
          },
        },
        {
          title: "Cars",
          icon: "mdi-car",
          to: "/app/cars",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "user"]);
          },
        },
        {
          title: "Membership",
          icon: "mdi-account-star",
          key: "membership",
          condition() {
            return userManager.checkRole(["user"]);
          },
          items: [
            {
              title: "Dashboard",
              to: `/app/charging_memberships_dashboard?userId=${userManager.getUserInfo()?._id || ''}`,
              condition() {
                return userManager.checkRole(["user"]);
              },
            },
            {
              title: "History",
              to: `/app/charging_memberships_usage_history?userId=${userManager.getUserInfo()?._id || ''}`,
              condition() {
                return userManager.checkRole(["user"]);
              },
            },
          ],
        },
        {
          title: "RFID Cards",
          icon: "mdi-card",
          to: "/app/tags",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]);
          },
        },
        {
          title: "Users",
          icon: "mdi-account-multiple",
          to: "/app/users",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "cpoGroup"]);
          },
        },
        {
          title: "Retailers",
          icon: "mdi-select-group",
          to: "/app/retailers",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin"], false, true);
          },
        },
        // {
        //   title: "Autocharge Vehicles",
        //   icon: "mdi-car",
        //   to: "/app/ocpp_autocharge_found_vehicles",
        //   condition() {
        //     return (
        //       configProvider.get("AUTOCHARGE_ENABLED") &&
        //       userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"])
        //     );
        //   },
        // },
        {
          title: "Statistics",
          icon: "mdi-chart-bar",
          to: "/app/statistics",
          condition() {
            return userManager.checkRole(["cpoAdmin", "cpoMonitor"], false, true);
          },
        },
        {
          title: "App Versions",
          icon: "mdi-apple",
          to: "/app/app-versions",
          condition() {
            return userManager.checkRole(["systemAdmin",  "admin"], false, true);
          },
        },
        {
          title: "Error Stations",
          icon: "mdi-alert-octagon-outline",
          to: "/app/error_stations",
          condition() {
            return userManager.checkRole(["systemAdmin",  "admin", "cpoAdmin", "cpoMonitor", "cpoGroup"]);
          },
        },
        {
          title: "Issues",
          icon: "mdi-comment-edit-outline",
          to: "/app/issues",
          condition() {
            return userManager.checkRole(["systemAdmin",  "admin", "cpoAdmin", "cpoMonitor"]);
          },
        },
        {
          title: "OCPP Logs",
          icon: "mdi-connection",
          to: "/app/ocpp_logs",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin"]);
          },
        },
        {
          title: "Settings",
          icon: "mdi-cog-outline",
          key: "settings",
          condition() {
            return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "user"]);
          },
          items: [
            {
              title: "Payment Exchange Ratio",
              to: "/app/settings/payment_exchange_ratio",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]);
              },
            },
            {
              title: "Payment Methods",
              to: "/app/settings/payment_methods",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]);
              },
            },
            {
              title: "Payment Transactions",
              to: "/app/settings/payment_transactions",
              condition() {
                return (
                  userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "user"]) &&
                  !userManager.isUserMobile()
                );
              },
            },
            {
              title: "Payment Transactions",
              to: "/app/settings/payment_transactions_m",
              condition() {
                return (
                  userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor", "user"]) &&
                  userManager.isUserMobile()
                );
              },
            },
            {
              title: "Time Zone",
              to: "/app/settings/time_zone",
            },
            {
              title: "Notify To Users",
              to: "/app/settings/notify_to_users",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin"]);
              },
            },
            {
              title: "Terms and Conditions",
              to: "/app/settings/terms_and_conditions",
              condition() {
                return userManager.checkRole(["systemAdmin"]);
              },
            },
            {
              title: "Privacy Policy",
              to: "/app/settings/privacy_policy",
              condition() {
                return userManager.checkRole(["systemAdmin"]);
              },
            },
            {
              title: "FAQ",
              to: "/app/settings/faq",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin"]);
              },
            },
            {
              title: "Docs",
              to: "/app/settings/docs",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin"]);
              },
            },
            {
              title: "Mail",
              to: "/app/settings/mail",
              condition() {
                return userManager.checkRole(["systemAdmin"]);
              },
            },
            {
              title: "ZNS Integration",
              to: "/app/settings/zns_integration",
              condition() {
                return userManager.checkRole(["systemAdmin", "admin"]);
              },
            },
            {
              title: "Roaming",
              to: "/app/settings/roaming",
              condition() {
                return userManager.checkRole(["systemAdmin"]);
              },
            },
            {
              title: "Feature Configuration",
              to: "/app/settings/feature_config",
              condition() {
                return userManager.checkRole(["systemAdmin"]);
              },
            },
          ],
        },
      ],
      userInfo: {},
      point: undefined,
      pointLoading: false,
      html5QrCode: null,
    };
  },
  computed: {
    featureConfig(): any {
      return this.$store.state.featureConfig;
    },
  },
  watch: {
    mini(value) {
      stateManager.set("navigationMenuMini", value);
    },
  },
  methods: {
    async logout() {
      userManager.deleteAccessToken();
      appService.deleteActiveTenant();
      this.$router.push("/login");
    },
    async resetActiveTenant() {
      appService.deleteActiveTenant();
    },
    async updateExpandedItem(key, value) {
      this.expandedItems[key] = value;
      stateManager.set("navigationMenuExpandedItems", this.expandedItems);
    },
    async qrScan() {
      let html5QrCode: Html5Qrcode = this.html5QrCode;
      if (!html5QrCode) {
        html5QrCode = new Html5Qrcode("qr-reader");
        this.html5QrCode = html5QrCode;
      }

      if (this.html5QrCode?.isScanning) {
        this.html5QrCode.stop();
      } else {
        html5QrCode.start(
          {
            facingMode: "environment",
          },
          {
            fps: 10,
          },
          (decodedText) => {
            location.href = decodedText;
            html5QrCode.stop();
          },
          () => {
          }
        );
      }
    },
  },
  async created() {
    if (!this.$vuetify.breakpoint.mobile) {
      this.mini = stateManager.get("navigationMenuMini", false);
    }
    const obj = stateManager.get("navigationMenuExpandedItems", {});
    for (const k in obj) {
      this.expandedItems[k] = obj[k];
    }

    this.userInfo = userManager.getUserInfo();

    {
      const setting = await coreApiClient.call("setting", "get");
      this.$store.commit("setFeatureConfig", setting?.featureConfig || null);
    }

    if (!userManager.isGuest() && userManager.checkRole(["user"], true)) {
      this.pointLoading = true;
      {
        const { point } = await coreApiClient.call("users", "findById", {
          id: userManager.getUserInfo()._id,
        });
        this.point = point || 0;
      }
      this.pointLoading = false;
    }
  },
});
